export default __webpack_public_path__ + "static/charamza-db2ecb6a9328d685bdc84d48a9c4c307.png";